// extracted by mini-css-extract-plugin
export default {"notFoundPage":"Error404Page_notFoundPage__pCQYm","images":"Error404Page_images__mt48V","link":"Error404Page_link__HNJKr"};